import React from 'react';

import iconCheck from '@/assets/icons/check.svg';

interface Plan {
  id: 'basic' | 'standard' | 'pro';
  name: string;
  price: string;
  benefits: string[];
  disabled?: boolean;
}

interface SubscriptionPlanBoxProps {
  plan: Plan;
  isActive: boolean;
  onSelect: (planId: string) => void;
}

const SubscriptionPlanBox: React.FC<SubscriptionPlanBoxProps> = ({ plan, isActive, onSelect }) => {
  const handleClick = () => {
    if (!plan.disabled) {
      onSelect(plan.id);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`border-2 rounded-[16px] p-[0.85rem] py-[0.6rem] transition-colors md:flex-1 md:pb-6 relative
          ${
            plan.disabled
              ? 'border-lightGray bg-gray-50 cursor-not-allowed opacity-60'
              : `cursor-pointer ${isActive ? 'border-primary bg-lightPurple' : 'border-lightGray bg-transparent'}`
          }`}
    >
      {plan.disabled && (
        <div className="absolute -top-2 -right-2 bg-primary text-white text-xs px-2 py-1 rounded-full font-medium">
          Coming Soon
        </div>
      )}
      <header className="flex items-center justify-between mb-[0.185rem] md:mb-[0.65rem]">
        <p className="md:text-lg">{plan.name}</p>
        <span
          className={`flex items-center justify-center rounded-full border-2 w-[20px] h-[20px]
            ${isActive && !plan.disabled ? 'border-primary' : 'border-lightGray'}`}
        >
          <span
            className={`bg-primary rounded-full w-[12px] h-[12px]
              ${isActive && !plan.disabled ? 'block' : 'hidden'}`}
          ></span>
        </span>
      </header>
      <h3 className="uppercase font-bold text-2xl md:text-[28px] md:border-b md:pb-[0.65rem]">
        {plan.price}
        {plan.id !== 'basic' && <span className="text-base font-normal capitalize ml-[3px] md:text-lg">/Month</span>}
      </h3>

      <div className="hidden mt-2 md:block">
        <p className="text-sm">Benefit</p>
        <ul className="mt-[0.9rem] flex flex-col gap-4">
          {plan.benefits.map((benefit, index) => (
            <li key={index} className="flex items-start gap-[0.6rem]">
              <span className="flex items-center justify-center rounded-full bg-lightPurple min-w-[20px] min-h-[20px]">
                <img src={iconCheck} alt="check-icon" />
              </span>
              <p className="leading-[19.5px] md:text-sm">{benefit}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SubscriptionPlanBox;
